module.exports = __webpack_public_path__ + "img/elevate-wellness-logo.b8dba3b6.png";